import React from 'react'
import { useSearchParams } from 'react-router'

import ContactUsButton from '@/components/misc/ContactUsButton'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { NYLAS_SEARCH_PARAMS } from '@/lib/constants'

const NylasCalendarConnectionFailedModal: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const shouldShow =
    searchParams.get(NYLAS_SEARCH_PARAMS.calendarConnectionFailed) === 'true'

  if (!shouldShow) {
    return null
  }

  function onHide() {
    searchParams.delete(NYLAS_SEARCH_PARAMS.calendarConnectionFailed)
    setSearchParams(searchParams)
  }

  return (
    <Dialog open onHide={onHide}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Please try connecting again</DialogTitle>
        </DialogHeader>

        <DialogBody>
          <p className="mb-4">
            Sorry but we were unable to connect to your calendar. This can
            sometimes happen because of temporary issues with the calendar
            provider (e.g., Outlook, Google, etc.) and can usually be resolved
            by trying again. Please try reconnecting your calendar now.
          </p>

          <p className="mb-4">
            If the issue persists, please{' '}
            <ContactUsButton>get in touch</ContactUsButton> and we can help.
          </p>
        </DialogBody>

        <DialogFooter>
          <Button variant="outline-secondary" onClick={onHide}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default NylasCalendarConnectionFailedModal
